<p class="paragraph-13">
    {{'thoughtRecord.assessment.questionXOfY' | translate:{index: index + 1, count: steps.length} }}
</p>
<h2 class="block-title">{{steps[index]}}</h2>

<ion-textarea rows="7"
              autocapitalize="on"
              spellcheck="true"
              [(ngModel)]="value"></ion-textarea>

<ion-button *ngIf="(!value || value.length == 0) && steps && index < steps.length - 1"
            fill="outline"
            color="primary"
            (click)="skip()">
    {{'thoughtRecord.assessment.skip' | translate}}
</ion-button>
<ion-button *ngIf="value && value.length > 0 && steps && index < steps.length - 1"
            fill="outline"
            color="primary"
            (click)="next()">
    {{'thoughtRecord.assessment.next' | translate}}
</ion-button>
<ion-button *ngIf="steps && index == steps.length - 1"
            fill="outline"
            color="primary"
            (click)="continue()">
    {{'thoughtRecord.assessment.continue' | translate}}
</ion-button>
